const defaultState = {
  data: [],
  shift_data: {},
  loading: false,
  error: false,
};

const crews = function (state = defaultState, action) {
  let target, data;

  switch (action.type) {
    case "SET_CREWS":
      return { ...state, data: action.data };

    case "SET_CREWS_SHIFT_DATA":
      return { ...state, shift_data: action.data };

    case "INSERT_CREW":
      return { ...state, data: [...state.data, action.data] };

    case "REMOVE_CREW":
      return {
        ...state,
        data: [...state.data.filter((d) => d.id !== action.data)],
      };

    case "UPDATE_CREW":
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target < 0) return state;
      data[target] = action.data;
      return { ...state, data };

    case "SET_CREWS_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_CREWS_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default crews;
